<template>
  <v-inventory-view
    name="production"
    title="productions"
    large
    to="/inventory/productions"
    v-bind:headers="headers"
    no-edit
    no-receive
    no-total
    inv-production
  >
    <template #header="{data}">
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title class="title">{{data.p_order}}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item>
        <v-list-item-content>
          <v-list-item-title>
            <span class="subtitle-2">{{$t('date')}}:</span>
            <span class="body-2">{{(new Date(data.created_time)).toLocaleString()}}</span>
          </v-list-item-title>
          <v-list-item-title>
            <span class="subtitle-2">{{$t('created_by')}}:</span>
            <span class="body-2">{{data.created_by}}</span>
          </v-list-item-title>
        </v-list-item-content>
        <v-list-item-content>
          <v-list-item-title>
            <span class="subtitle-2">{{$t('store')}}:</span>
          </v-list-item-title>
          <v-list-item-subtitle>
            <span class="body-2">{{data.service_name}}</span>
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-inventory-view>
</template>
<script>
export default {
  name: "InventoryProductionsView",
  data: () => ({}),
  computed: {
    headers() {
      let headers = [
        { text: "Item", value: "name" }
      ]
      
      if(this.user_access && this.user_access.inv_productions_cost) {
        headers.push({ text: "Cost", value: "cost", align: 'right' })
      }
      headers.push({ text: "Quantity", value: "quality", align: 'right' })
      return headers
    }
  },
  mounted() {}
};
</script>
